(function () {
  'use strict';
  if (!window.WcDiscovery) return;
  let storage;
  try { storage = window.localStorage; } catch (_) { /* Private browsing. */ }
  const canPersist = () => window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true;
  let history = WcDiscovery.createHistory(storage, 'wc-au-recent-searches-v1', canPersist, 6);
  let viewed = WcDiscovery.createHistory(storage, 'wc-au-recent-products-v1', canPersist, 8);
  let consentAllowed = canPersist();
  const currentProduct = document.getElementById('WcCurrentProductHandle');
  let currentHandle;
  if (currentProduct) {
    try { currentHandle = JSON.parse(currentProduct.textContent); } catch (_) { /* Invalid optional context. */ }
  }
  const rememberCurrent = () => { if (currentHandle) viewed.add(currentHandle); };
  rememberCurrent();

  function renderRecent(container) {
    const list = container.querySelector('[data-wc-recent-list]');
    if (!list) return;
    const panel = list.closest('[data-wc-recent]');
    list.replaceChildren();
    const terms = history.read();
    panel.hidden = terms.length === 0;
    terms.forEach((term) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'reversed-link';
      link.textContent = term;
      link.href = WcDiscovery.searchURL(container.querySelector('form').action, term, location.origin);
      item.append(link);
      list.append(item);
    });
  }

  document.addEventListener('focusin', (event) => {
    const search = event.target.closest('predictive-search');
    if (search) renderRecent(search);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-wc-search-form]');
    if (form && form.querySelector('input[name="q"]')) history.add(form.querySelector('input[name="q"]').value);
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wc-recent-clear]');
    if (button) {
      history.clear();
      document.querySelectorAll('predictive-search').forEach(renderRecent);
    }
  });

  class WcRecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.refresh();
    }
    refresh() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.observer = null;
      const generation = this.generation = (this.generation || 0) + 1;
      this.hidden = true;
      const list = this.querySelector('[data-wc-recent-products]');
      list?.replaceChildren();
      const handles = viewed.read().filter((handle) => /^[a-z0-9-]+$/.test(handle) && handle !== this.dataset.current)
        .slice(0, Number(this.dataset.limit) || 4);
      if (!handles.length) return;
      let loaded = false;
      const load = () => {
        if (loaded || !this.isConnected || generation !== this.generation) return;
        loaded = true;
        this.observer?.disconnect();
        this.observer = null;
        this.controller = new AbortController();
        Promise.all(handles.map(async (handle) => {
          try {
            const url = new URL(`${this.dataset.root}products/${encodeURIComponent(handle)}`, location.origin);
            url.searchParams.set('section_id', 'wc-recent-card');
            const response = await fetch(url, {signal: this.controller.signal});
            if (!response.ok) return null;
            const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
            return parsed.querySelector('[data-wc-recent-card]');
          } catch (_) { return null; }
        })).then((cards) => {
          if (!this.isConnected || generation !== this.generation || !list) return;
          list.replaceChildren(...cards.filter(Boolean));
          this.hidden = list.children.length === 0;
        });
      };
      // The hidden custom element has no layout box. Its Shopify wrapper still
      // marks its position below the product content without adding a spacer.
      const section = this.closest('.shopify-section');
      if (section && typeof IntersectionObserver === 'function') {
        try {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) load();
          }, { rootMargin: '400px 0px' });
          this.observer.observe(section);
          return;
        } catch (_) {
          this.observer?.disconnect();
          this.observer = null;
        }
      }
      load();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.observer = null;
      this.generation = (this.generation || 0) + 1;
      this.started = false;
    }
  }
  if (!customElements.get('wc-recently-viewed')) customElements.define('wc-recently-viewed', WcRecentlyViewed);

  function refreshConsent() {
    const allowed = canPersist();
    if (allowed === consentAllowed) return;
    consentAllowed = allowed;
    if (!allowed) {
      // Forget in-memory copies of previously allowed persistent history.
      // Do not read, write or delete the stored history after revocation.
      history = WcDiscovery.createHistory(storage, 'wc-au-recent-searches-v1', canPersist, 6);
      viewed = WcDiscovery.createHistory(storage, 'wc-au-recent-products-v1', canPersist, 8);
    }
    rememberCurrent();
    document.querySelectorAll('predictive-search').forEach(renderRecent);
    document.querySelectorAll('wc-recently-viewed').forEach((element) => element.refresh());
  }
  document.addEventListener('visitorConsentCollected', refreshConsent);
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    try {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], (error) => {
        if (!error) refreshConsent();
      });
    } catch (_) { /* Stay memory-only when the privacy API is unavailable. */ }
  }
})();
